import { Box, Divider, List, Typography } from "@mui/material";

import localisations from "../../../localisation";

function PreAlertConfirmationStage(props: any) {
    const {
        heading,
        blurb,
        detailsHeading,
        customerSpecificHeading,
        itemsHeading,
        partitionNameLabel,
        supplierNameLabel,
        warehouseNameLabel,
        requiredDateLabel,
        wbsCodeLabel,
        aucCodeLabel,
        orderRaiserLabel,
        po1NumberLabel,
        po2NumberLabel,
        materialNumberLabel,
        quantityLabel,
        unitValueLabel,
        productLabel,
        currencyCodeLabel,
    } = localisations.createPreAlert.stages.confirmation;

    const fields = props.fields;

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>

            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>

            <br />
            <Typography variant="h6" gutterBottom>
                {detailsHeading}
            </Typography>
            <Typography variant="body1">
                {partitionNameLabel}: {fields.partitionDetails.name}
            </Typography>
            <Typography variant="body1">
                {supplierNameLabel}: {fields.supplierDetails.name}
            </Typography>
            <Typography variant="body1">
                {warehouseNameLabel}: {fields.warehouseDetails.name}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {requiredDateLabel}: {fields.requiredDate}
            </Typography>

            <br />
            <Typography variant="h6" gutterBottom>
                {customerSpecificHeading}
            </Typography>
            <Typography variant="body1">
                {wbsCodeLabel}: {fields.customerFields.wbsCode}
            </Typography>
            <Typography variant="body1">
                {aucCodeLabel}: {fields.customerFields.aucCode}
            </Typography>
            <Typography variant="body1">
                {orderRaiserLabel}: {fields.customerFields.orderRaiser}
            </Typography>
            <Typography variant="body1">
                {po1NumberLabel}: {fields.customerFields.poNumber}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {po2NumberLabel}: {fields.customerFields.po2Number}
            </Typography>
            <br />

            <Typography variant="h6" gutterBottom>
                {itemsHeading}
            </Typography>
            <List sx={{ pt: 0 }}>
                {fields.items.map((x: any, index: number) => (
                    <Box key={index}>
                        <Typography variant="body1">
                            {productLabel}: {x.productSku}
                        </Typography>
                        <Typography variant="body1">
                            {materialNumberLabel}: {x.materialNumber}
                        </Typography>
                        <Typography variant="body1">
                            {quantityLabel}: {x.quantity}
                        </Typography>
                        <Typography variant="body1">
                            {currencyCodeLabel}: {x.currencyCode}
                        </Typography>
                        <Typography variant="body1">
                            {unitValueLabel}: {x.unitValue}
                        </Typography>
                        {index + 1 !== fields.items.length && <Divider sx={{ mt: 2, mb: 2 }}></Divider>}
                    </Box>
                ))}
            </List>
        </>
    );
}

export default PreAlertConfirmationStage;
